{
  "1 Location": "1 Location",
  "1 Location, {{timePeriod}}": "1 Location, {{timePeriod}}",
  "Abandoned": "Abandoned",
  "Add Campaign Number": "Add Campaign Number",
  "Add a campaign name for each selected phone number to track its marketing source.": "Add a campaign name for each selected phone number to track its marketing source.",
  "Add campaign numbers to view your Marketing Attribution insights": "Add campaign numbers to view your Marketing Attribution insights",
  "Adjust the average appointment value to better reflect your practice's revenue.": "Adjust the average appointment value to better reflect your practice's revenue.",
  "Analytics": "Analytics",
  "Answer Rate": "Answer Rate",
  "Answered": "Answered",
  "Average per Appointment": "Average per Appointment",
  "Back": "Back",
  "Bulk Text": "Bulk Text",
  "Call Breakdown": "Call Breakdown",
  "Calls": "Calls",
  "Calls + SMS": "Calls + SMS",
  "Calls Only": "Calls Only",
  "Campaign Name": "Campaign Name",
  "Campaign Numbers": "Campaign Numbers",
  "Campaign numbers have been successfully updated.": "Campaign numbers have been successfully updated.",
  "Campaigns": "Campaigns",
  "Cancel": "Cancel",
  "Capabilities": "Capabilities",
  "Compare campaign performance ": "Compare campaign performance ",
  "Completed": "Completed",
  "Completion Rate": "Completion Rate",
  "Continue": "Continue",
  "Conversion Funnel": "Conversion Funnel",
  "Done": "Done",
  "Edit Average Appointment Value": "Edit Average Appointment Value",
  "Est. Production": "Est. Production",
  "Existing": "Existing",
  "Existing Patients": "Existing Patients",
  "Failed to fetch the campaign numbers.": "Failed to fetch the campaign numbers.",
  "Fax": "Fax",
  "Inbound Lead Tracking": "Inbound Lead Tracking",
  "Inbound Marketing Lead Tracking": "Inbound Marketing Lead Tracking",
  "Incoming Calls": "Incoming Calls",
  "Incoming Leads": "Incoming Leads",
  "Incoming SMS": "Incoming SMS",
  "Last Month": "Last Month",
  "Last Quarter": "Last Quarter",
  "Loading demo data...": "Loading demo data...",
  "Location": "Location",
  "Manage Campaign Numbers": "Manage Campaign Numbers",
  "Marketing Analytics": "Marketing Analytics",
  "Missed": "Missed",
  "Name Your Campaign": "Name Your Campaign",
  "New": "New",
  "New Campaign Number": "New Campaign Number",
  "New Patients": "New Patients",
  "Number of leads that successfully converted into completed appointments.": "Number of leads that successfully converted into completed appointments.",
  "Number of leads that successfully converted into scheduled appointments.": "Number of leads that successfully converted into scheduled appointments.",
  "Patient Classification": "Patient Classification",
  "Phone Number": "Phone Number",
  "Phone Number Name": "Phone Number Name",
  "Represents the total number of leads generated through incoming calls and messages.": "Represents the total number of leads generated through incoming calls and messages.",
  "Revenue": "Revenue",
  "SMS": "SMS",
  "SMS Only": "SMS Only",
  "Schedule Rate": "Schedule Rate",
  "Scheduled": "Scheduled",
  "Select phone numbers to use for your campaign": "Select phone numbers to use for your campaign",
  "Showing results for {{filtersInfo}}": "Showing results for {{filtersInfo}}",
  "This Month": "This Month",
  "This Quarter": "This Quarter",
  "Total Calls": "Total Calls",
  "Total Leads": "Total Leads",
  "Total SMS": "Total SMS",
  "Total production value associated with completed appointments originating from leads.": "Total production value associated with completed appointments originating from leads.",
  "Tracks all incoming calls categorized by status, providing visibility into call handling performance.": "Tracks all incoming calls categorized by status, providing visibility into call handling performance.",
  "Tracks leads by patient type, New Patients and Existing Patients, to help evaluate how marketing efforts attract and retain patients.": "Tracks leads by patient type, New Patients and Existing Patients, to help evaluate how marketing efforts attract and retain patients.",
  "Tracks the percentage of leads progressing through each stage to show how effectively leads are converting into completed appointments.": "Tracks the percentage of leads progressing through each stage to show how effectively leads are converting into completed appointments.",
  "Voice": "Voice",
  "vs last period": "vs last period",
  "vs previous month": "vs previous month",
  "vs previous quarter": "vs previous quarter",
  "vs previous week": "vs previous week",
  "{{count}} locations, {{timePeriod}}_one": "{{count}} locations, {{timePeriod}}",
  "{{count}} locations, {{timePeriod}}_other": "{{count}} locations, {{timePeriod}}",
  "{{filteredLocationsCount}} Locations": "{{filteredLocationsCount}} Locations"
}
